export enum ePlanType {
  MONTHLY,
  ANNUALY,
}

export enum ePlanIdentifier {
  FREE = "free",
  BRONZE_MENSAL = "bronze_mensal",
  BRONZE_ANUAL = "bronze_anual",
  PRATA_MENSAL = "prata_mensal",
  PRATA_ANUAL = "prata_anual",
  OURO_MENSAL = "ouro_mensal",
  OURO_ANUAL = "ouro_anual",
}

export interface Plan {
  title: string;
  price: string;
  type: ePlanType;
  /**
   * Comes from API
   */
  priceId?: string;
  features: string[];
  icon: {
    element: any;
  };
  identifier: string;
  canTrial: boolean;
}

export interface StoredPlan {
  id: number;
  title: string;
  identifier: string;
  price_id: string;
  is_active: boolean;
  created_at: Date;
  updated_at: Date;
}
